import React from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

interface UnsavedChangesModalProps {
  open: boolean
  onConfirm: () => void
  onCancel: () => void
  contentText?: string
  confirmText?: string
  cancelText?: string
}

const defaultText =
  'You have unsaved changes. If you continue, these changes will be lost. Are you sure you want to proceed?'

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  open,
  onConfirm,
  onCancel,
  contentText,
  confirmText = 'Discard Changes',
  cancelText = 'Stay on Page',
}) => (
  <Dialog
    open={open}
    onClose={(_event, reason) => {
      if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
        return
      }
      onCancel()
    }}
    aria-labelledby='unsaved-changes-dialog-title'
    maxWidth='sm'
    fullWidth
  >
    <DialogTitle id='unsaved-changes-dialog-title'>Unsaved Changes</DialogTitle>
    <DialogContent>
      <DialogContentText>{contentText || defaultText}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} color='primary' variant='outlined'>
        {cancelText}
      </Button>
      <Button onClick={onConfirm} color='primary' variant='contained' autoFocus>
        {confirmText}
      </Button>
    </DialogActions>
  </Dialog>
)

export default UnsavedChangesModal
